var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content flex justify-center align-center"},[_c('a',{attrs:{"href":"http://101.37.16.168/resources/soft/XY-v1.0.1.zip"}},[_vm._v("小Y-v1.0：下载")])])])
}]

export { render, staticRenderFns }